import {observer} from "mobx-react"
import {App} from "./App"
import {VdaCreatePage, VdaDetailPage, VdaOverviewPage} from "../page/vda"

const VdaApp = observer(function VdaApp({mode}: {mode: 'overview' | 'create' | 'detail'}) {
    return <App>
        {mode === 'overview' && <VdaOverviewPage />}
        {mode === 'detail' && <VdaDetailPage />}
        {mode === 'create' && <VdaCreatePage />}

    </App>
})

export {
    VdaApp
}
